// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton-module__skeleton___e56Cv","placeholderShimmer":"skeleton-module__placeholderShimmer___PgkDV","circle":"skeleton-module__circle___WLw8v"};